import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/Users/jamesdigioia/Code/brookjs/packages/brookjs-docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0f6094c59493c16b3bda26d305660238.js')["default"];

var scope_1 = require('/Users/jamesdigioia/Code/brookjs/packages/brookjs-docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

export default Object.assign({}, scope_0, scope_1);